import {
  ClientQuestionnaireKeynameEnum,
} from '../../../../../../../common/src/enums/client-questionnaire/client-questionnaire-keyname.enum';
import {
  ClientQuestionnaireStatusEnum,
} from '../../../../../../../common/src/enums/client-questionnaire/client-questionnaire-status.enum';

export class QuestionnaireUtils {
  static getName(keyname: ClientQuestionnaireKeynameEnum): string {
    switch (keyname) {
      case ClientQuestionnaireKeynameEnum.QuebecTaxForm2021:
        return 'Impôt Québec et Canada 2021';
      case ClientQuestionnaireKeynameEnum.QuebecTaxForm2022:
        return 'Impôt Québec et Canada 2022';
      case ClientQuestionnaireKeynameEnum.QuebecTaxForm2023:
        return 'Impôt Québec et Canada 2023';
    }
  }

  static getStatusText(status: ClientQuestionnaireStatusEnum): string {
    switch (status) {
      case ClientQuestionnaireStatusEnum.Created:
        return 'En cours';
      case ClientQuestionnaireStatusEnum.InProgress:
        return 'En cours';
      case ClientQuestionnaireStatusEnum.Finalized:
        return 'Complété';
    }
  }
}
